import React, { forwardRef } from 'react'
import { ButtonProps } from '@chakra-ui/core'
import colors from 'constants/colors'

import { ReactComponent as IconSend } from 'assets/icon-send.svg'
import { NoFocusButton } from './NoFocusButton'

interface IProps extends Omit<ButtonProps, 'children'> {
  isLoading?: boolean
  onClick?: VoidFunction
  tabIndex?: number
  isDisabled?: boolean
}

// eslint-disable-next-line react/prop-types
export const PublishButton = forwardRef<HTMLButtonElement, IProps>(
  ({ isLoading, onClick, tabIndex, isDisabled, ...props }, ref) => {
    return (
      <NoFocusButton
        ref={ref}
        borderRadius="full"
        bg={isLoading ? 'transparent' : colors.greenLight2}
        minWidth="auto"
        opacity={isDisabled || isLoading ? 0.5 : 1}
        width="44px"
        height="44px"
        cursor="pointer"
        justifyContent="center"
        alignItems="center"
        p="0"
        background={colors.greenDark}
        onClick={onClick}
        tabIndex={tabIndex}
        isDisabled={isDisabled || isLoading}
        {...props}
      >
        <IconSend />
      </NoFocusButton>
    )
  }
)
